// @flow
import FormikPhoneField from 'components/formik/FormikPhoneField'
import FormikTextField from 'components/formik/FormikTextField'
import * as React from 'react'

type Props = {
  isEditMode: boolean,
}

function ClientDemographicsTableEmergencyContact({
  isEditMode,
}: Props): React.Node {
  return (
    <div className="grid grid-cols-12 gap-x-6 gap-y-4 pt-1">
      <div className="col-span-12 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="First name"
          name="emergency_contact.first_name"
          placeholder="First name"
        />
      </div>
      <div className="col-span-12 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="Last name"
          name="emergency_contact.last_name"
          placeholder="Last name"
        />
      </div>
      <div className="col-span-12 md:col-span-6">
        <FormikPhoneField
          disabled={!isEditMode}
          label="Phone"
          name="emergency_contact.phone_number"
          placeholder="Phone number"
        />
      </div>
      <div className="col-span-12 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="Relationship"
          name="emergency_contact.relationship"
          placeholder="Relationship"
        />
      </div>
      <div className="col-span-6 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="Address"
          name="emergency_contact.address"
          placeholder="Address"
        />
      </div>
      <div className="col-span-6 md:col-span-6">
        <FormikTextField
          disabled={!isEditMode}
          label="Apt or Ste #"
          name="emergency_contact.address2"
          placeholder="Apt or Ste #"
        />
      </div>
      <div className="col-span-6 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="City"
          name="emergency_contact.city"
          placeholder="City"
        />
      </div>
      <div className="col-span-6 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="State"
          name="emergency_contact.state"
          placeholder="State"
        />
      </div>
      <div className="col-span-6 md:col-span-4">
        <FormikTextField
          disabled={!isEditMode}
          label="Zip"
          name="emergency_contact.zipcode"
          placeholder="Zip"
        />
      </div>
    </div>
  )
}

export default ClientDemographicsTableEmergencyContact
